import * as React from "react";
import { Tag } from "@workflows/ui";
import { Trans, useTranslation } from "react-i18next";

export interface ChangedStatusActivityProps {
  activity: any;
}

export function ChangedStatusActivity({
  activity,
}: ChangedStatusActivityProps): JSX.Element {
  const { toObject, actor, insertedAt } = activity;
  const { t } = useTranslation("ai.workflows.activities");

  return (
    <div>
      <Trans i18nKey="ChangedStatusActivity" t={t}>
        {{ actorName: actor.name }} changed the status to{" "}
        <Tag color={toObject.color} textColor={toObject.textColor} size="sm">
          {{ objectName: toObject.name }}
          {{ insertedAt }}
        </Tag>
      </Trans>
    </div>
  );
}
